
import Vue from 'vue';
import { UiMenuItem } from '@/model';
import Secured from '@/components/Secured.vue';
import SkeletonLoader from '@/components/SkeletonLoader.vue';
import Snackbar from '@/components/Snackbar.vue';
import Searchbar from '@/components/Searchbar.vue';
import MenuTreeItem from '@/components/MenuTreeItem.vue';
import realms from '@/store/realms';
import labels from '@/store/labels';
import users from '@/store/users';
import publishers from '@/store/publisher';
import authModule, { AuthState } from '@/store/auth-module';
import uiConfig, { defaultMenuItems, titleForRoute } from '@/store/ui-config';

export default Vue.extend({
  name: 'App',

  components: {
    MenuTreeItem,
    Snackbar,
    Searchbar,
    Secured,
    SkeletonLoader,
  },

  data: () => ({
    loading: true,
  }),

  computed: {
    pageTitle(): string {
      return titleForRoute(this.$route.path) ?? this.$route.name ?? '';
    },
    menu(): UiMenuItem[] {
      return uiConfig.state.config?.menu?.items ?? defaultMenuItems as UiMenuItem[];
    },
    hotDogOrNotHotDog(): boolean {
      const today = new Date();
      const dd = today.getDate();
      const mm = today.getMonth() + 1;
      return dd === 1 && mm === 4;
    },
    testingNotInProd(): boolean {
      return window.location.hostname === 'maia-test.acuminor.com';
    },
    state() {
      return authModule.state.state;
    },
  },

  watch: {
    state: {
      immediate: true,
      async handler(next: AuthState) {
        if (next === 'authorized' && this.loading === true) {
          await this.preload();
          this.loading = false;
        }
      },
    },
  },

  methods: {
    async preload(): Promise<void> {
      await uiConfig.dispatch.load();
      await Promise.all([
        users.dispatch.all(),
        realms.dispatch.all(),
        labels.dispatch.all(),
        publishers.dispatch.all(),
      ]);
    },
    toggleDarkMode(): void {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem('darkMode', String(this.$vuetify.theme.dark));
    },
  },
});
